@for (section of statusBarSections; track $index) {
  @if (section.width) {
    <div
      data-test-id="status-item"
      class="status-item"
      [class]="section.cssClass"
      [style.width.%]="section.width"
      [style.max-width.%]="section.width"
      [ngbTooltip]="section.tooltipText ? tooltipTemplate : undefined"
      [tooltipClass]="'default-tooltip status-bar-tooltip'"
      [placement]="'top bottom'"
      (click)="section.clickHandler()"
    ></div>
  }
  <ng-template #tooltipTemplate>
    <div data-test-id="status-tooltip">{{ section.tooltipText }}</div>
  </ng-template>
}
